import { MyLeadsSearchQuery } from '@mm/state/interfaces/myLeads';
import { Tag } from 'antd';
import classNames from 'classnames';
import { isEqual } from 'lodash';
import React, { useLayoutEffect } from 'react';
import { useSuggestedAudiencesPresets } from '../../hooks/use-suggested-audiences-presets';
import styles from './SuggestedAudiences.module.css';

type Props = {
  filterParams: MyLeadsSearchQuery;
  setFilterParams: (params: MyLeadsSearchQuery) => void;
  activePreset: string;
  setActivePreset: (preset: string) => void;
};

export const SuggestedAudiences = ({
  setActivePreset,
  activePreset,
  filterParams,
  setFilterParams,
}: Props) => {
  const { presets } = useSuggestedAudiencesPresets();
  const defaultPreset = presets.find(preset => activePreset === preset.key);

  const onPresetClick = (
    query: MyLeadsSearchQuery,
    key: string,
    customOnClick?: () => void,
  ) => {
    if (customOnClick) {
      customOnClick();
      setActivePreset(key);
      return;
    }
    if (activePreset === key) {
      setFilterParams({ query: {} });
      setActivePreset('');
    } else {
      setFilterParams(query);
      setActivePreset(key);
    }
  };

  useLayoutEffect(() => {
    if (!isEqual(filterParams, defaultPreset?.searchQuery)) {
      setActivePreset('');
    }
  }, [filterParams]);

  return (
    <div className={styles.container}>
      <div className={styles.filters}>
        {presets.map(preset => (
          <Tag
            key={preset.key}
            color={preset.color || 'geekblue'}
            className={classNames(styles.tag, {
              [styles.activeTag]: activePreset === preset.key,
            })}
            closable={false}
            onClick={() => {
              onPresetClick(
                preset.searchQuery,
                preset.key,
                preset?.customOnClick,
              );
            }}
          >
            {preset.name}
          </Tag>
        ))}
      </div>
      <div className={styles.footer}>
        or create your own with the filters below
      </div>
    </div>
  );
};
